import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Container, Typography } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import axios from "axios";
import { encryptData } from '../../utils/cryptoUtils';
import config from '../../config';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import '../common.scss';

const CreateYardMaster = () => {

  const { id } = useParams();

  const navigate = useNavigate();
    const userInfo = useSelector((state) => state.userInfo);
 

    const loggedInUserId = userInfo?.id;
       console.log(loggedInUserId);
  const [formData, setFormData] = useState({
    yard_name: '',
    yard_address: '',
    status: ''
  });

  const handleChange = (e) => {

    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });

  };

const handleSubmit = async (e) => {

  e.preventDefault();

  try {

    const params = {

      id: id ? atob(id) : '',

      yard_name: formData.yard_name,

      yard_address: formData.yard_address,

      status: formData.status,

      user_id: loggedInUserId

    };

    const requestData = encryptData(params);

    const response = await axios.post(
      `${config.API_BASE_URL}saveYardMaster`,
      requestData
    );

    if (response.data.success === 1) {

        toast.success(response.data.message);

        navigate('/dashboard/yard-master');

      } else {

        toast.error(response.data.message);

      }

  } catch (error) {

  console.log(error);

  console.log(error.response);

  toast.error(
    error?.response?.data?.message || "Something went wrong"
  );

}

};

useEffect(() => {

  if (id) {

    const decodedId = atob(id);

    axios
      .get(`${config.API_BASE_URL}getYardMaster/${decodedId}`)
      .then((result) => {

        if (result.data.status) {

          const data = result.data.data;

          setFormData({
            yard_name: data.yard_name || '',
            yard_address: data.yard_address || '',
            status: data.status || ''
          });

        }

      })
      .catch((error) => {

        console.log(error);

      });

  }

}, [id]);

  return (
    <>
      <Helmet>
        <title>{id ? "Edit Yard" : "Create Yard"}</title>
      </Helmet>

      <Container>

        <Typography variant="h4" sx={{ mb: 4 }}>
          {id ? "Edit Yard" : "Create Yard"}
        </Typography>

        <form onSubmit={handleSubmit}>

          <div id='main-wrap'>

            <div className='row'>

              <div className='col-md-6'>
                <div className='form-group'>

                  <label htmlFor="yard_name">

                    <span>
                      Yard Name <a style={{ color: "red" }}>*</a>
                    </span>

                    <input
                      type='text'
                      id='yard_name'
                      name='yard_name'
                      className='form-control'
                      placeholder='Enter yard name'
                      value={formData.yard_name}
                      onChange={handleChange}
                    />

                  </label>

                </div>
              </div>

              <div className='col-md-6'>
                <div className='form-group'>

                  <label htmlFor="status">

                    <span>
                      Status <a style={{ color: "red" }}>*</a>
                    </span>

                    <select
                      id='status'
                      name='status'
                      className='form-select'
                      value={formData.status}
                      onChange={handleChange}
                    >
                      <option value="">Select Status</option>
                      <option value="1">Active</option>
                      <option value="2">Inactive</option>
                    </select>

                  </label>

                </div>
              </div>

              <div className='col-md-12'>
                <div className='form-group'>

                  <label htmlFor="yard_address">

                    <span>
                      Yard Address <a style={{ color: "red" }}>*</a>
                    </span>

                    <textarea
                      id='yard_address'
                      name='yard_address'
                      className='form-control'
                      rows="4"
                      placeholder='Enter yard address'
                      value={formData.yard_address}
                      onChange={handleChange}
                    />

                  </label>

                </div>
              </div>

              <div className='col-md-12'>
                <div className='form-group mb-2 mt-2'>

                  <button
                    type='submit'
                    className='btn btn-primary'
                  >
                    {id ? "Update Yard" : "Submit"}
                  </button>

                </div>
              </div>

            </div>

          </div>

        </form>

      </Container>
    </>
  );
}

export default CreateYardMaster;